module.exports = __webpack_public_path__ + "static/img/preview-05.ef646734.webp";